import { isSuccess } from '@/context/services/type';
import { isCommonError } from '@/libs/typeguard/isError';
import {
  InvoiceReportApprovalRouteResponse,
  useGetInvoiceReportApprovalRouteSuspense,
} from 'ap-openapi';

export type InvoiceReportApprovalRouteResult = {
  data?: InvoiceReportApprovalRouteResponse;
  error?: {
    messages?: string[] | string;
    code?: string;
  };
};

export const useInvoiceReportApprovalRoute = (
  reportId: string
): InvoiceReportApprovalRouteResult => {
  const { data, error } = useGetInvoiceReportApprovalRouteSuspense(reportId, {
    query: { queryKey: ['invoiceReportApprovalRoute', reportId] },
  });

  if (error) throw error;

  const body = data?.data;
  if (!isSuccess(data?.status)) {
    if (typeof body === 'object' && isCommonError(body)) {
      return {
        error: {
          messages: body?.messages,
          code: data?.status.toString(),
        },
      };
    }
    return {
      error: { messages: undefined, code: data?.status.toString() },
    };
  }

  return { data: body };
};
